
import React from 'react';
import { Progress } from '@/components/ui/progress';
import { Badge } from '@/components/ui/badge';
import { Star, Award, Gamepad, Sparkles } from 'lucide-react';

interface XPProgressProps {
  xp: number;
  level: number;
  nextLevelXp: number;
}

const XPProgress: React.FC<XPProgressProps> = ({ xp, level, nextLevelXp }) => {
  const percentage = Math.min(Math.round((xp / nextLevelXp) * 100), 100);
  
  return (
    <div className="space-y-2 p-3 border border-white/10 rounded-md glass-panel">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="relative">
            <Star className="h-6 w-6 text-yellow-500 fill-yellow-500" />
            <span className="absolute inset-0 flex items-center justify-center text-xs font-bold text-black">{level}</span>
          </div>
          <div>
            <span className="font-medium text-gradient-neon">Artist Level {level}</span>
            <p className="text-xs text-muted-foreground">Keep creating to level up!</p>
          </div>
        </div>
        <Badge variant="game" className="flex items-center gap-1 font-bold">
          <Sparkles className="h-3 w-3 text-yellow-400" />
          <span>{xp.toLocaleString()} XP</span>
        </Badge>
      </div>
      
      <div className="space-y-1">
        <Progress 
          value={percentage} 
          className="h-2.5 game-progress" 
          indicatorClassName="bg-gradient-to-r from-yellow-500 via-amber-400 to-yellow-300"
        />
        <div className="flex justify-between text-xs text-muted-foreground">
          <span>{xp.toLocaleString()} XP</span>
          <span>{nextLevelXp.toLocaleString()} XP needed for Level {level + 1}</span>
        </div>
      </div>
      
      <div className="flex justify-between text-xs pt-1 border-t border-white/10 mt-1">
        <span className="flex items-center gap-1">
          <Gamepad className="h-3 w-3 text-neon-purple" />
          <span>Game Achievements: 12/50</span>
        </span>
        <span className="flex items-center gap-1">
          <Award className="h-3 w-3 text-neon-blue" />
          <span>Badges Earned: 8</span>
        </span>
      </div>
    </div>
  );
};

export default XPProgress;
